import React from 'react';

import { fontSize } from '../../styles/constants';
import type { WaitPositionProps } from '../../types';

/**
 * GPS permission prompt — shown while waiting for the user to allow browser geolocation.
 * Explains that position data stays local and is not shared or saved.
 * Renders as a full-screen overlay with a Cancel button.
 *
 * @param props.waitForPos - Whether to show the prompt
 * @param props.setWaitForPos - Callback to dismiss (set false to cancel)
 */
export const WaitPosition: React.FC<WaitPositionProps> = ({ waitForPos, setWaitForPos }) => {
  if (!waitForPos) return null;

  return (
    <div
      style={{
        fontSize,
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        background: 'white',
      }}
    >
      <div style={{ position: 'fixed', top: '40vmin', left: 0, right: 0, textAlign: 'center' }}>
        <p>Waiting for position...</p>
        <hr />
        <div>
          Awaiting your choice of allowing browser positioning.
          <br />
          Should you allow this, the application will be sensitive to your position.
          <br />
          Your position will not be shared over the network and it will not be saved.
        </div>
        <hr />
        <button onClick={() => setWaitForPos(false)}>Cancel</button>
      </div>
    </div>
  );
};
